// ساخته‌ی tools/marpele_car_cut.py — دستی ویرایش نکن.
/** بومِ ماشین‌های مارپله (پیکسل) و لنگر: وسطِ زیرِ چرخ‌ها؛ پهنای ماشین و راننده. نشانِ خانه‌ی جادویی: icon. */
export const CAR_ART = { w: 426, h: 301, ax: 213, ay: 294, body: 300, icon: [150, 112] } as const;
